module.exports = __webpack_public_path__ + "static/media/HFI-HT.122b467a.png";